import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Helmet from 'react-helmet';

import { settings } from "../../assets/settings";
import { Path } from '../../constants/path';

export const defaults = {
  name: settings.title,
  title : settings.lead+" - "+settings.title,
  description: settings.description,
  image : process.env.PUBLIC_URL+settings.root+"images/thumnail.jpg"
};

class Meta extends Component {

  componentDidMount = () => {
  }

  getTitle = () => {
    return this.props.title != null ? this.props.title + " | " + defaults.title : defaults.title;
  }

  getDescription = () => {
    return this.props.description != null ? this.props.description + "|" + defaults.description : defaults.description;
  }

  getImage = () => {
    return this.props.image != null ? this.props.image : defaults.image;
  }

  getUrl = () => {
    return this.props.url != null ? this.props.url : process.env.PUBLIC_URL + this.props.history.location.pathname;
  }

  render = () => {
    return (
      <div>
        <Helmet
          title={this.getTitle()}
          description={this.getDescription()}
          meta={[
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: this.getTitle() },
            { name: 'twitter:description', content: this.getDescription() },
            { name: 'twitter:image', content: this.getImage() },

            { property: 'fb:app_id', content: "" },
            { property: 'og:title', content: this.getTitle() },
            { property: 'og:site_name', content: defaults.name },
            { property: 'og:type', content: 'website' },
            { property: 'og:url', content: this.getUrl() },
            { property: 'og:image', content: this.getImage() },
            { property: 'og:description', content: this.getDescription() },
          ]}
        />
      </div>
    );
  }
}


const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
    }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Meta))
